<template>

    <div class="page-center content-load animated fadeIn">

        <div class="container">
            <div class="row">
                <div class="col-xs-12 col-xl-4 col-xl-offset-4 col-md-6 col-md-offset-3">

                    <div class="login-register-page">

                        <center>
                            <img src="static/images/logo.png" width="180" class="logo margin-bottom-20">
                        </center>                        
                        
                        <div class="welcome-text margin-bottom-30 margin-top-10">
                            <h3 class="margin-bottom-10">
                                <ion-icon name="create-outline"></ion-icon>
                                Complete seu cadastro
                            </h3>
                            <span>
                                
                            </span>
                        </div>

                        <form method="post" id="register-account-form" v-on:submit.prevent="submit" novalidate="">
                            
                            <div class="dashboard-box margin-top-0 mobile">

                                <div class="content with-padding">

                                    <div class="row">                        
                                        <div class="col-lg-12">
                                            <p class="page-text margin-bottom-20 margin-top-0">
                                                Envie corretamente as fotos abaixo. Lembre-se que todas essas informações são para sua própria segurança.
                                            </p>
                                        </div>  

                                        <div class="col-lg-11 col-xs-12 margin-bottom-0">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>
                                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                                    Tipo do veículo
                                                </h5>
                                            </div>                                      
                                        </div>                                      

                                        <div class="col-xs-12 col-xl-12 margin-bottom-5">    
                                            <button type="button" class="button  small block-mobile" style="border-width: 1px !important; width: 100%;" v-on:click="form.veiculoTipo = 'bike';" v-bind:class="{'color-secondary': form.veiculoTipo == 'bike', 'outline-black': form.veiculoTipo != 'bike'}">
                                                <ion-icon v-if="form.veiculoTipo != 'bike'" name="ellipse-outline" style="font-size: 18px; top: 9px; position: absolute; left: 8px;"></ion-icon>
                                                <ion-icon v-if="form.veiculoTipo == 'bike'" name="checkmark-circle-outline" style="font-size: 18px; top: 9px; position: absolute; left: 8px;"></ion-icon>
                                                Bicicleta
                                            </button>
                                        </div>
                                        <div class="col-xl-12">
                                        </div>
                                        <div class="col-xs-12 col-xl-12 margin-bottom-5">    
                                            <button type="button" class="button  small block-mobile" style="border-width: 1px !important; width: 100%;" v-on:click="form.veiculoTipo = 'moto';" v-bind:class="{'color-secondary': form.veiculoTipo == 'moto', 'outline-black': form.veiculoTipo != 'moto'}">
                                                <ion-icon v-if="form.veiculoTipo != 'moto'" name="ellipse-outline" style="font-size: 18px; top: 9px; position: absolute; left: 8px;"></ion-icon>
                                                <ion-icon v-if="form.veiculoTipo == 'moto'" name="checkmark-circle-outline" style="font-size: 18px; top: 9px; position: absolute; left: 8px;"></ion-icon>
                                                Moto
                                            </button>                                            
                                        </div>
                                        <div class="col-xl-12">
                                        </div>                                                  
                                        <div class="col-xs-12 col-xl-12 margin-bottom-20">    
                                            <button type="button" class="button  small block-mobile" style="border-width: 1px !important; width: 100%;" v-on:click="form.veiculoTipo = 'carro';" v-bind:class="{'color-secondary': form.veiculoTipo == 'carro', 'outline-black': form.veiculoTipo != 'carro'}">
                                                <ion-icon v-if="form.veiculoTipo != 'carro'" name="ellipse-outline" style="font-size: 18px; top: 9px; position: absolute; left: 8px;"></ion-icon>
                                                <ion-icon v-if="form.veiculoTipo == 'carro'" name="checkmark-circle-outline" style="font-size: 18px; top: 9px; position: absolute; left: 8px;"></ion-icon>
                                                Carro
                                            </button>                                            
                                        </div>      

                                        <div class="col-lg-11 col-xs-12 margin-bottom-15" v-if="form.veiculoTipo == 'moto' || form.veiculoTipo == 'carro'">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>
                                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                                    Placa do veículo
                                                </h5>
                                            </div>  

                                            <the-mask :mask="['XXX-XXXX', 'XXXX-XXXX']" type="text" :masked="true" class="with-border" onkeydown="var self = this; setTimeout(function() {self.value = self.value.toUpperCase();}, 10);" 
                                                    autocomplete="new-password" v-model="form.veiculoPlaca" placeholder="____-_____" required />
                                        </div>  

                                        <div class="col-lg-12 col-xs-12 margin-bottom-15">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>
                                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                                    Foto do veículo
                                                </h5>
                                            </div>  

                                            <div class="uploadButton margin-bottom-0" style="width: 100%; display: inline-block;">
                                                <input class="uploadButton-input" type="file" name="imagemVeiculo" @change="getBase64Imagem" accept="image/*" :id="'upload-arquivo-imagemVeiculo'" capture />
                                                <label class="uploadButton-button outline-black" :for="'upload-arquivo-imagemVeiculo'">
                                                </label>
                                                <button type="button" class="button outline-black block-mobile small" v-on:click="escolherImagem('imagemVeiculo', true)">
                                                    <ion-icon name="camera-outline"></ion-icon>
                                                    {{!form.imagemVeiculo ? 'Enviar foto' : 'Alterar foto'}}
                                                </button>
                                                <!-- <span class="uploadButton-file-name"></span> -->
                                                <!-- <small style="display: block; line-height: 130%">Tire uma foto da lateral.</small>                              -->
                                            </div>                 
                                            <div class="imagem-preview" v-on:click="escolherImagem('imagemVeiculo')" v-if="form.imagemVeiculo" :style="{'background-image': 'url(' + form.imagemVeiculo + ')'}"></div>                                       
                                        </div>    
                                                                        

                                        <div class="col-lg-12 col-xs-12 margin-bottom-15">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>
                                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                                    Foto de perfil do app
                                                </h5>
                                            </div>  

                                            <avatar-cropper
                                              :output-options="{'width': 800, 'height': 800}"
                                              :output-quality="0.6"
                                              :labels="{ 'submit': 'Ok', 'cancel': 'Cancelar'}"
                                              :upload-handler="uploadAvatar"
                                              trigger="#avatar-imagem"
                                              @submit="submitAvatar"
                                              @uploading="uploadAvatar" />

                                            <div class="uploadButton margin-bottom-0" style="width: 100%; display: inline-block;">
                                                <input class="uploadButton-input" type="file" name="imagem" @change="getBase64Imagem" accept="image/*" :id="'upload-arquivo-imagem'" />
                                                <label class="uploadButton-button outline-black" :for="'upload-arquivo-imagem'">
                                                </label>
                                                <button type="button" class="button outline-black block-mobile small" id="avatar-imagem">
                                                    <ion-icon name="camera-outline"></ion-icon>
                                                    {{!form.imagem ? 'Enviar foto' : 'Alterar foto'}}
                                                </button>
                                                <!-- <span class="uploadButton-file-name"></span> -->
                                            </div>       
                                            <div class="imagem-preview" v-on:click="escolherImagem('imagem')" v-if="form.imagem" :style="{'background-image': 'url(' + form.imagem + ')'}"></div>                                       
                                        </div>                                           

                                        <div class="col-lg-12 col-xs-12 margin-bottom-15">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5>
                                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                                    Foto de um documento (frente e verso)
                                                </h5>
                                            </div>  

                                            <div class="uploadButton margin-bottom-0" style="width: 100%; display: inline-block;">
                                                <input class="uploadButton-input" type="file" name="imagemDoc" @change="getBase64Imagem" accept="image/*" :id="'upload-arquivo-imagemDoc'" capture />
                                                <label class="uploadButton-button outline-black" :for="'upload-arquivo-imagemDoc'">
                                                </label>
                                                <button type="button" class="button outline-black block-mobile small" v-on:click="escolherImagem('imagemDoc')">
                                                    <ion-icon name="camera-outline"></ion-icon>
                                                    {{!form.imagemDoc ? 'Enviar foto' : 'Alterar foto'}}
                                                </button>
                                                <small style="display: block; line-height: 130%">Pode ser CNH, RG, CPF...</small>                             
                                            </div>                 
                                            <div class="imagem-preview" v-on:click="escolherImagem('imagemDoc')" v-if="form.imagemDoc" :style="{'background-image': 'url(' + form.imagemDoc + ')'}"></div>                                       
                                        </div>  

                                        <div class="col-lg-12 col-xs-12 margin-bottom-15">
                                            <div class="section-headline margin-top-0 margin-bottom-0">
                                                <h5 >
                                                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                                                    Foto de rosto segurando o documento acima
                                                </h5>                                            
                                            </div>  

                                            <div class="uploadButton margin-bottom-0" style="width: 100%; display: inline-block;">
                                                <input class="uploadButton-input" type="file" name="imagemDocPerfil" @change="getBase64Imagem" accept="image/*" :id="'upload-arquivo-imagemDocPerfil'" capture />
                                                <label class="uploadButton-button outline-black" :for="'upload-arquivo-imagemDocPerfil'">
                                                </label>
                                                <button type="button" class="button outline-black block-mobile small" v-on:click="escolherImagem('imagemDocPerfil')">
                                                    <ion-icon name="camera-outline"></ion-icon>
                                                    {{!form.imagemDocPerfil ? 'Enviar foto' : 'Alterar foto'}}
                                                </button>
                                                <small style="display: block; line-height: 130%" >Tire uma foto segurando a sua CNH, RG..</small>                             
                                            </div>                 
                                            <div class="imagem-preview" v-on:click="escolherImagem('imagemDocPerfil')" v-if="form.imagemDocPerfil" :style="{'background-image': 'url(' + form.imagemDocPerfil + ')'}"></div>                                       
                                        </div>                                             

                                        <div class="col-lg-12 col-xs-12 margin-top-20 margin-bottom-0">
                                                                                                                              
                                            <button class="button full-width color-secondary" type="submit">
                                                <span>Prosseguir</span>
                                                <ion-icon name="arrow-forward-outline"></ion-icon>
                                            </button>
                                            <a class="button block-mobile margin-top-10 color-gray" v-on:click="$root.logout();" style="opacity: 0.5; width: 100%; text-align: center !important;">
                                                <ion-icon name="arrow-back-outline"></ion-icon>
                                                Sair
                                            </a>                                    
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper"
export default {
    name:                           'Cadastro2',
    components: {
        'AvatarCropper':            AvatarCropper
    },     
    data () {
        var self                    = this;
        return {
            termos:                 true,
            loading: {
                "submit":           false,
            },
            form: {
                "etapa":            2,
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "imagem":           "",
                "veiculoTipo":      self.$root.user.veiculoTipo,
                "veiculoPlaca":     self.$root.user.veiculoPlaca,
                "imagemDoc":        self.$root.user.imagemDoc,
                "imagemDocPerfil":  self.$root.user.imagemDocPerfil,
                "imagemVeiculo":    self.$root.user.imagemVeiculo,
            }
        }
    },
    methods: {
        submitAvatar: function(e) {
            var self = this;
            console.log("submitAvatar()", e)
            loading.show();
        },    
        uploadAvatar: function(e) {
            var self = this;
            console.log("uploadAvatar()", e)
            loading.show();
            // self.form.imagem = e.getCroppedCanvas().toDataURL();
            e.getCroppedCanvas().toBlob((blob1) => {
                reduceFileSize(blob1, 500*1024, 800, Infinity, 0.6, blob2 => {
                    blobToBase64(blob2, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form.imagem    = result;
                        self.$forceUpdate();
                    });
                });             
            });
            // setTimeout(function() {
            //     loading.hide();
            // }, 500);
            return true;
        },           
        getBase64Imagem: function(event) {
            var self            = this;
            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 800, Infinity, 0.6, blob => {
                    blobToBase64(blob, function(result) {
                        setTimeout(function() {
                            loading.hide();
                        }, 500);
                        self.form[event.target.id.split("-")[2]]    = result;
                    });
                }); 
            } else {
                setTimeout(function() {
                    loading.hide();
                }, 500);                
            } 
        },              
        escolherImagem: function(campo, camera) {
            console.log("escolherImagem()", campo)
            var self = this;
            if (!window.cordova) {
                $(".uploadButton-button[for='upload-arquivo-" + campo + "']").click();        
            } else {

                if (camera) {
                    loading.show();
                    navigator.camera.getPicture(function(imageData) {
                        self.form[campo] = "data:image/jpeg;base64," + imageData;
                        console.log("setou form", campo)
                        self.$forceUpdate();
                        loading.hide();
                    }, function(message){
                        console.log("erro", message)
                        loading.hide();
                    }, {
                        quality: 35,
                        // saveToPhotoAlbum: true,
                        destinationType: Camera.DestinationType.DATA_URL,
                        targetWidth: 1000,
                        correctOrientation: true,
                        targetHeight: 0
                    });
                } else {
                    navigator.notification.confirm(
                        '', 
                        function(buttonIndex) {
                            if (buttonIndex == 1) {
                                loading.show();
                                navigator.camera.getPicture(function(imageData) {
                                    self.form[campo] = "data:image/jpeg;base64," + imageData;
                                    console.log("setou form", campo)
                                    self.$forceUpdate();
                                    loading.hide();
                                    
                                }, function(message){
                                    console.log("erro", message)
                                    loading.hide();

                                }, {
                                    quality: 35,
                                    // saveToPhotoAlbum: true,
                                    destinationType: Camera.DestinationType.DATA_URL,
                                    targetWidth: 1000,
                                    correctOrientation: true,
                                    targetHeight: 0
                                });                        
                            }
                            if (buttonIndex == 2) {
                                $(".uploadButton-button[for='upload-arquivo-" + campo + "']").click();        
                            }                    
                        },          
                        'Escolher foto',   
                        ['Câmera','Galeria'] 
                    );               
                }
            }
        },
        submit: function(e) {
            var self            = this;
            e.preventDefault();
            self.loading.submit = true;
            $(".loading-text").html("Enviando fotos, aguarde..");
            loading.show();
            axios.post("api/cadastro.php", self.form)
            .then(response => {
                // self.loading.submit = false;
                $(".loading-text").html("");
             
                if (response.data.user) {
                    self.$root.setUser(response.data.user).then(function() {
                        alert(response.data.message);
                        setTimeout(function() {
                           self.$router.push({"name": "Cadastro3"});
                        }, 200);
                    
                    });
                } else {
                    loading.hide();
                }
            })
            .catch(error => {
                $(".loading-text").html("");
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        }
    },
    created: function() {
        var self = this;
        self.$root.getUser();
    },
    mounted: function() {
        loading.hide();
        $("#app")[0].scrollTo({
            top:    0
        });        
    } 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >

    .current-page-cadastro2 .loading {
        top: 0px !important;
    }   

    .current-page-cadastro2 {
        background-image: url(/static/images/bg3.png);
        background-size: cover;
        background-repeat: repeat;
        background-position: center;
    }
    .page-cadastro2 #wrapper {
        background: #fe0100 !important;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
    }   

   
    .page-cadastro2 .container {
        margin-top: 35px !important;
        padding-left: 15px;
        padding-right: 15px;
        margin-bottom: 20px;
    }
    .page-cadastro2 input {
        margin-bottom: 7px;
    }
    .page-cadastro2 .input-with-icon-left i {
        background: transparent;
        border-right: none;
    }
    .page-cadastro2 .input-with-icon-left i {
        color: #fe0100;
    }
    .page-cadastro2 .selo {
        bottom: 0px;
        width: 100%;
        display: block;
        margin-top: 0px;
        text-transform: uppercase;
        font-size: 10px;
        margin-bottom: 10px;
        text-align: center;
        letter-spacing: 0px;
        color: #444;
    }
    .page-cadastro2 .section-headline {
        padding-right: 0px;
    }       
    .page-cadastro2 .button.small.block-mobile ion-icon {
        /*font-size: 30px;*/
    }
    .page-cadastro2 .button.small.block-mobile {
        line-height: 130%;
        font-weight: 400;
        padding-top: 10px;
        padding-bottom: 10px;
        text-align: center;
        background: #fff;
        border: 1px solid #EFEFEF;
        color: #555;
        width: 100%;
    }
    .page-cadastro2 .welcome-text h3 ion-icon {
        color: #fff !important;

    }
    .page-cadastro2 .welcome-text h3 {
        color: #fff !important;
    }

    .current-page-cadastro2 .loading {
        top: 0px !important;
    } 

    .page-cadastro2 input {
        margin-bottom: 5px;
    }
    .page-cadastro2 .input-with-icon-left i {
        background: transparent;
        border-right: none;
    }
    .page-cadastro2 .input-with-icon-left i {
        color: #000;
    }
    .page-cadastro2 .section-headline {
        padding-right: 0px;
    }
    .page-cadastro2 .container.cadastro {
        margin-top: 25px !important;
        padding-left: 20px;
        padding-right: 20px;
        /*margin-bottom: 20px;*/
    }

    .page-cadastro2 .uploadButton-button {
        display: none !important;
    }        
    .page-cadastro2 .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .page-cadastro2 .imagem-preview {
        width: 100%;
        height: 25vh;
        border-radius: 10px;
        margin-bottom: 25px;
        background-size: auto 100%;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }
    
    .page-cadastro2 h5 {
        font-size: 16px;
        line-height: 130%;
        font-weight: 500;
    }

    .page-cadastro2 h5 ion-icon {
        color: green;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cadastro2.vue